module.exports = __webpack_public_path__ + "static/media/Cover-min.87b802f6.png";